module.exports = new __parcel__URL__("goals-preview.8d233f18.svg").toString();